const HistoryColumns = [
  {
    title: "ID",
    field: "id",
    locked: false,
    filter: "text",
    width: "150px",
    show: true,
  },
  {
    title: "Query Name",
    field: "queryName",
    locked: false,
    filter: "text",
    width: "300px",
    show: true,
  },
  {
    title: "Group Name",
    field: "permissionType",
    locked: false,
    filter: "text",
    width: "200px",
    show: true,
  },
  // {
  //   title: "Status",
  //   field: "status",
  //   locked: false,
  //   filter: "text",
  //   width: "180px",
  //   show: true,
  // },
  {
    title: "Created At",
    field: "createdOn",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: "auto",
    show: true,
  },
];

export default HistoryColumns;
